import { useEffect, useState } from 'react';
import { configuracoesApi } from '../services/api';

export function useRestaurantName() {
  const [name, setName] = useState<string>(() => localStorage.getItem('restaurante_nome') || 'inReservas');

  useEffect(() => {
    let cancelled = false;
    // tenta buscar sem auth (AllowAnonymous) — se falhar, mantém fallback
    configuracoesApi
      .getByChave('restaurante_nome')
      .then((d) => {
        if (cancelled) return;
        const v = d?.data?.valor;
        if (v && typeof v === 'string' && v.trim()) {
          setName(v.trim());
          localStorage.setItem('restaurante_nome', v.trim());
        }
      })
      .catch(() => {
        // silencioso: mantém fallback local
      });
    // também escuta atualizações via storage (quando admin altera)
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'restaurante_nome' && e.newValue) setName(e.newValue);
    };
    window.addEventListener('storage', onStorage);
    return () => { cancelled = true; window.removeEventListener('storage', onStorage); };
  }, []);

  return name;
}
